import React from "react"
import { Col, Container, Row } from "react-bootstrap"
const EstateDisclaimer = () => {
  return (
    <Container>
      <Row>
        <Col>
          <p style={{padding: '20px', textAlign: 'center'}}>
            <em>
              Powyższa oferta ma charakter informacyjny i&nbsp;nie stanowi oferty handlowej w&nbsp;rozumieniu art.&nbsp;66&nbsp;§1&nbsp;Kodeksu&nbsp;Cywilnego.

            </em>
          </p>
        </Col>
      </Row>
    </Container>
  )
}

export default EstateDisclaimer
